<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-12 11:14:04
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-24 19:37:44
-->
<template>
	<!-- 达人联系人 -->
	<div class="drContactsCell">
		<el-select
			ref="template"
			v-model="nickName"
			:loading-text="loading_cont"
			clearable
			filterable
			:loading="loadingContact_cont"
			remote
			@change="selectChange"
			:remote-method="remoteContactMethod_cont"
			@visible-change="v => visibleChange(v, 'template')"
			@focus="focusContactFun_cont"
			placeholder="请选择 / 搜索"
		>
			<el-option v-for="(item, index) in contactOptions" :key="index" :value="item.nick_name" :label="item.nick_name">
				<span class="contact-name">{{ item.nick_name }}</span>
				<span v-if="item.mobile">/</span>
				<span>{{ item.mobile }}</span>
			</el-option>
		</el-select>
		<linkman-dialog ref="linkmanDialog" @getContact="getContact" />
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { contactList } from '@/api/extenTecord';
import linkmanDialog from '@/views/talentCRM/components/linkmanDialog';
export default {
	name: 'drContactsCell',
	mixins: [mixin],
	props: {},
	mounted() {
		this.$Bus.$on('sendContactOptions', val => {
			this.parentList = val;
		});
	},
	beforeDestroy() {
		this.$Bus.$off('sendContactOptions');
	},
	watch: {
		nickName(val) {
			this.row.isGetAddress = true;
			const anchorContactId = val ? this.anchorContactId || this.contactOptions?.find(v => v.nick_name === val)?.id : '';
			const nickName = val;
			this.anchorContactId = '';
			this.$Bus.$emit('drSelectChange', anchorContactId, this.rowId, nickName);
			//推出去将数据将对应的达人联系人id绑定了
		},
		rowId(newval, oldval) {
			this.anchorContactId = this.parentList?.find(v => v.id == this.rowId)?.team_institution_id;
			this.nickName = this.parentList?.find(v => v.id == this.rowId)?.nickName;
			this.$Bus.$emit('resetTzId', oldval);
		},
	},
	computed: {
		rowId() {
			return this.row.id;
		},
	},
	data() {
		return {
			nickName: '',
			loading_cont: '加载中',
			loadingContact_cont: false,
			contactOptions: [], //存储了列表中的id和contact_name
			isShowRadio: false,
			parentList: [],
			selectDaren: '',
			dataMap: {},
			isShow: true,
			anchorContactId: '',
		};
	},
	components: {
		linkmanDialog,
	},
	methods: {
		visibleChange(visible, refName) {
			if (visible) {
				const ref = this.$refs[refName];
				let popper = ref.$refs.popper;
				if (popper.$el) popper = popper.$el;
				if (!Array.from(popper.children).some(v => v.className === 'el-template-menu__list')) {
					const el = document.createElement('ul');
					el.className = 'el-template-menu__list';
					el.style = 'border-top:1px solid #EAEBF0; padding:0; color:rgb(64 158 255);font-size: 13px';
					el.innerHTML = `<li class="el-cascader-node text-center" style="height:37px;line-height: 50px">
                        <span class="yx-color-primary"><i class="font-blue el-icon-plus"></i>新增联系人</span>
                        </li>`;
					popper.appendChild(el);
					el.onclick = () => {
						this.addContacts();
					};
				}
			}
		},
		selectChange(e) {},
		//联系人远程搜索
		async remoteContactMethod_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({ anchor_id: this.row.id, nick_name: e, unbind_wechat: this.isShowRadio ? '1' : '' });
			this.loadingContact_cont = false;
			if (code == 0) {
				this.contactOptions = data.list;
			}
		},
		async focusContactFun_cont(e) {
			this.loadingContact_cont = true;
			this.loading_cont = '加载中';
			const { code, data } = await contactList({
				anchor_id: this.row.id,
				nick_name: '',
				unbind_wechat: this.isShowRadio ? '1' : '',
			});
			if (code == 0) {
				this.contactOptions = data.list;
				data.list.length ? (this.loadingContact_cont = false) : (this.loading_cont = '无数据');
			}
		},
		//添加联系人
		addContacts() {
			const { anchor_name, anchor_account, head, platform_id, id: anchor_id, anchor_uid, check_status } = this.row;
			const anchor_info = {
				anchor_name,
				anchor_account,
				head,
				platform_id,
				anchor_uid,
				check_status,
			};
			// 需要传3个参数，第一个为建联需要的表单，第二个为当前对象，第三个为新建还是关联联系人1或0
			this.$refs.linkmanDialog.show(
				{
					anchor_id,
					operate_time: Date.now(),
					is_pass: 1,
					contact_type: 1,
				},
				anchor_info,
				1,
			);
		},
		//新增联系人之后
		getContact(params) {
			this.nickName = params?.contact_name;
			this.anchorContactId = params?.id;
		},
	},
};
</script>
<style lang="less" scoped>
.contact-name {
	float: left;
	color: #1d2129;
	margin-left: 10px;
}
/deep/ .el-input__inner {
	font-size: 12px !important;
}
</style>
